/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Devices API
 * AV Services Devices management API
 * OpenAPI spec version: 1.0
 */
import { CURRENT_CLIENT_TEMPLATE_VAR } from '@core';
import { HttpClient } from '@angular/common/http';

import { Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import type {
  CreateMeasurementUnitDto,
  MeasurementUnitsControllerCreateV1201,
  MeasurementUnitsControllerCreateV1PathParameters,
  MeasurementUnitsControllerDeleteV1PathParameters,
  MeasurementUnitsControllerFindAllV1200AllOf,
  MeasurementUnitsControllerFindAllV1PathParameters,
  MeasurementUnitsControllerUpdateV1200,
  MeasurementUnitsControllerUpdateV1PathParameters,
  UpdateMeasurementUnitDto,
} from '../models';

@Injectable({ providedIn: 'root' })
export class MeasurementUnitsService {
  private readonly http = inject(HttpClient);
  /**
   * @summary Retrieve all measurement units
   */

  findAll<TData = MeasurementUnitsControllerFindAllV1200AllOf>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
  }: MeasurementUnitsControllerFindAllV1PathParameters): Observable<TData> {
    return this.http.get<TData>(`/devices/v1/clients/${clientId}/measurement-units`);
  }
  /**
   * @summary Create a new measurement unit
   */

  create<TData = MeasurementUnitsControllerCreateV1201>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR }: MeasurementUnitsControllerCreateV1PathParameters,
    createMeasurementUnitDto: CreateMeasurementUnitDto,
  ): Observable<TData> {
    return this.http.post<TData>(`/devices/v1/clients/${clientId}/measurement-units`, createMeasurementUnitDto);
  }
  /**
   * @summary Update an existing measurement unit
   */

  update<TData = MeasurementUnitsControllerUpdateV1200>(
    { clientId = CURRENT_CLIENT_TEMPLATE_VAR, id }: MeasurementUnitsControllerUpdateV1PathParameters,
    updateMeasurementUnitDto: UpdateMeasurementUnitDto,
  ): Observable<TData> {
    return this.http.patch<TData>(`/devices/v1/clients/${clientId}/measurement-units/${id}`, updateMeasurementUnitDto);
  }
  /**
   * @summary Delete a measurement unit
   */

  delete<TData = void>({
    clientId = CURRENT_CLIENT_TEMPLATE_VAR,
    id,
  }: MeasurementUnitsControllerDeleteV1PathParameters): Observable<TData> {
    return this.http.delete<TData>(`/devices/v1/clients/${clientId}/measurement-units/${id}`);
  }
}
